module.exports = __webpack_public_path__ + "static/media/Routine-red.21c9a37d.svg";